import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import isEmail from 'sane-email-validation';
import TextField from './TextField.js';
import useConfigWithExtraValidation from '../../utils/form/useExtraFieldValidation.js';

function removeSpaces(value) {
  return value.replace(/\s/g, '');
}
function getInvalidEmailError(value) {
  var trimmedValue = typeof value === 'string' && value.trim();
  if (trimmedValue) {
    if (!isEmail(removeSpaces(trimmedValue))) {
      return 'Invalid email';
    }
  }

  // else no email to validate, I don't enforce "required" in this rule. No errors.
  return null;
}
function EmailField(textFieldProps) {
  return /*#__PURE__*/React.createElement(TextField, _extends({}, textFieldProps, {
    autoComplete: "email"
    // Add email validation
    ,
    config: useConfigWithExtraValidation(textFieldProps.config, getInvalidEmailError)
  }));
}
EmailField.propTypes = process.env.NODE_ENV !== "production" ? TextField.propTypes : {};
EmailField.defaultProps = TextField.defaultProps;

export { EmailField as default };
